import { globalState } from '../../state/globalState';

export type StructuralEntity = 'template' | 'field';
export type StructuralAction = 'create' | 'edit' | 'reorder' | 'retire';

export const STRUCTURAL_OFFLINE_BLOCKED_TITLE = 'Conexão necessária';
export const STRUCTURAL_OFFLINE_BLOCKED_MESSAGE =
  'Alterações de modelos, campos e ordem ficam bloqueadas offline para preservar o histórico. Conecte-se e tente novamente. O preenchimento de checklists, valores e fotos continua disponível offline.';

export type StructuralGateResult =
  | {
      allowed: true;
      entity: StructuralEntity;
      action: StructuralAction;
      status: 'allowed';
      reason: 'online_structural_operation';
    }
  | {
      allowed: false;
      entity: StructuralEntity;
      action: StructuralAction;
      status: 'blocked';
      reason: 'structural_offline_blocked';
      title: typeof STRUCTURAL_OFFLINE_BLOCKED_TITLE;
      message: typeof STRUCTURAL_OFFLINE_BLOCKED_MESSAGE;
    };

export const assertStructuralOnline = (
  entity: StructuralEntity,
  action: StructuralAction,
  isOnline: boolean = globalState.network.isConnected.get(),
): StructuralGateResult => {
  if (!isOnline) {
    return {
      allowed: false,
      entity,
      action,
      status: 'blocked',
      reason: 'structural_offline_blocked',
      title: STRUCTURAL_OFFLINE_BLOCKED_TITLE,
      message: STRUCTURAL_OFFLINE_BLOCKED_MESSAGE,
    };
  }

  return {
    allowed: true,
    entity,
    action,
    status: 'allowed',
    reason: 'online_structural_operation',
  };
};
